import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/layout/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/layout/Navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/sections/About.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/sections/AiFeatures.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/sections/FinalCta.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/sections/ForPartners.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/sections/ForTeachers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/sections/Hero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/sections/InPartnership.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/sections/Journey.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/sections/ProgramOverview.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/sections/WhatYouGet.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/sections/WhoItsFor.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/sections/WhyItMatters.tsx");
